module.exports = __webpack_public_path__ + "img/pure_oak_946e_detail_rsh.2c3dbbe8.jpg";